import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router';

import { styled } from '@mui/material';

import { CenteredLoader, Typography } from '@app-velocity/ui';

import { useRequestGateway } from '@app-velocity/request-gateway';

import { useI18n } from '@app-velocity/i18n';

import { HappyFace } from '@app-velocity/animations';

import { useReadKeysQuery } from '../../queries/useReadKeysQuery';
import { useRouterContext } from '../../router/useRouterContext';

const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(8),
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  svg: {
    fill: '#1b1b1b',
  },
}));

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledTitle = styled(Typography)({
  fontSize: 48,
  lineHeight: 1,
  fontWeight: 500,
});

export const AuthSuccessPage = () => {
  const { type } = useParams<{ type: 'figma' | 'google' }>();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [readKey, setReadKey] = useState('');
  const { writeTokens } = useRequestGateway();
  const { data: readKeyData } = useReadKeysQuery(readKey);
  const { strategy } = useRouterContext();

   
  useEffect(() => {
    if (strategy === 'FIGMA_PLUGIN') return;

    const storedKey = window.sessionStorage.getItem('readKey');

    if (!storedKey) return;
    window.sessionStorage.removeItem('readKey');
    setReadKey(storedKey);
  }, []);

  // used only in web app
  useEffect(() => {
    if (!readKeyData) return;
    const { accessToken, refreshToken } = readKeyData;

    if (!accessToken || !refreshToken) return;

    const currentDate = new Date();
    const futureDate = currentDate.setMinutes(currentDate.getMinutes() + 10);

    writeTokens({
      accessToken,
      refreshToken,
      accessTokenExpiration: futureDate,
      refreshTokenExpiration: futureDate,
    });

    const originalUrl = window.sessionStorage.getItem('originalUrl');

    if (originalUrl) {
      window.sessionStorage.removeItem('originalUrl');
      navigate(originalUrl);

      return;
    }

    navigate('/');
  }, [readKeyData]);

  // if key is available to immediately fetch tokens
  if (readKey) return <CenteredLoader />;

  if (!type) return;

  return (
    <StyledWrapper>
      <StyledContainer>
        <HappyFace />
        <StyledTitle>{t('users:auth.success')}</StyledTitle>
        <Typography>{t(`users:auth.${type}_success`)}</Typography>
      </StyledContainer>
    </StyledWrapper>
  );
};
